import moment from "moment";
import React from "react";
import { Button, ControlLabel, FormGroup, InputGroup } from "react-bootstrap";
import Datetime from "react-datetime";
import FontAwesome from "react-fontawesome";
import Select from "react-select-plus";

import { formatCrewName } from "../../../utils";
import CrewName from "../CrewName";
import EditCrew from "../EditCrew";

const transformCrewToOption = (crew) => ({
  crew,
  disabled: crew.disabled,
  label: formatCrewName(crew),
  value: crew.id,
});

const unassignedCrewOption = {
  crew: null,
  label: "Unassigned",
  value: "",
};

const getCrewOptions = (purchaseOrderCrew, standardCrews) =>
  [
    unassignedCrewOption,
    purchaseOrderCrew ? transformCrewToOption(purchaseOrderCrew) : null,
    {
      label: "Standard Crews",
      options: standardCrews.map(transformCrewToOption),
    },
  ].filter((e) => !!e);

class EditDelivery extends React.Component {
  static get propTypes() {
    return {};
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      editCrew: false,
    };

    this.handleEditCrewClick = this.handleEditCrewClick.bind(this);
  }

  handleEditCrewClick() {
    this.setState({
      editCrew: true,
    });
  }

  render() {
    const { equipment, onChange, purchaseOrder, resources, standardCrews } =
      this.props;
    const { editCrew } = this.state;

    return (
      <div>
        <FormGroup>
          <ControlLabel>Delivery Date</ControlLabel>
          <Datetime
            input={false}
            timeFormat={false}
            onChange={(e) =>
              onChange({
                ...purchaseOrder,
                ...(purchaseOrder.isInventoryPO
                  ? { deliveryDate: e.format("YYYY-MM-DD") }
                  : { dateDelivered: e.format("YYYY-MM-DD") }),
              })
            }
            value={
              purchaseOrder.isInventoryPO
                ? purchaseOrder.deliveryDate
                  ? moment(purchaseOrder.deliveryDate)
                  : ""
                : purchaseOrder.dateDelivered
                ? moment(purchaseOrder.dateDelivered)
                : ""
            }
          />
        </FormGroup>
        <hr />
        {editCrew ? (
          <EditCrew
            crew={purchaseOrder.crew}
            showpercentage={true}
            onChange={(crew) => onChange({ ...purchaseOrder, crew })}
            equipment={equipment}
            resources={resources}
          />
        ) : (
          <FormGroup>
            <ControlLabel>Crew</ControlLabel>
            <InputGroup>
              <InputGroup.Button>
                <Button onClick={this.handleEditCrewClick}>
                  <FontAwesome name="pencil" />
                </Button>
              </InputGroup.Button>
              <Select
                clearable={false}
                onChange={({ crew }) =>
                  onChange({ ...purchaseOrder, crew: crew || null })
                }
                optionRenderer={(o) =>
                  o.crew ? <CrewName crew={o.crew} /> : o.label
                }
                options={getCrewOptions(purchaseOrder.crew, standardCrews)}
                placeholder="Unassigned"
                value={purchaseOrder.crew ? purchaseOrder.crew.id : ""}
                valueRenderer={(o) => <CrewName crew={o.crew} />}
              />
            </InputGroup>
          </FormGroup>
        )}
      </div>
    );
  }
}

export default EditDelivery;
